import { createElement } from "react";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { requirePermission } from "../../../../shared/routing/requirePermission";
import { MODULE_MANAGEMENT_UPDATE } from "../../catalogPermissions";
import { catalogSearchSchema } from "./searchSchemas";
import type { CatalogRouteFactory } from "./catalogRouteContext";

const CatalogListScreen = lazyRouteComponent(
  () => import("../CatalogListScreen"),
  "CatalogListScreen",
);

// Selling-price control is on-page dialog, not separate route
export const createCatalogListRoutes: CatalogRouteFactory = ({
  context,
  catalog,
}) => [
  createRoute({
    getParentRoute: context.getParentRoute,
    path: context.basePath,
    validateSearch: catalogSearchSchema,
    beforeLoad: requirePermission([MODULE_MANAGEMENT_UPDATE]),
    component: () =>
      createElement(CatalogListScreen, {
        repository: catalog,
        basePath: context.basePath,
      }),
  }),
];
